import { useEffect, useRef } from 'react'
import { createChart, ColorType } from 'lightweight-charts'
import { MiniChartContainer } from './styled'

export const MiniSwapLineChart = ({ data, isBelow }) => {
  const convertData = data.map((item) => ({
    // 毫秒 -> 秒
    time: item.timestamp / 1000,
    value: item.price,
  }))

  const chartContainerRef = useRef(null)

  const chartOptions = {
    layout: {
      background: {
        type: ColorType.Solid,
        color: 'transparent',
      },
    },
    rightPriceScale: {
      visible: false,
    },
    timeScale: {
      visible: false,
    },
    grid: {
      vertLines: {
        visible: false,
      },
      horzLines: {
        visible: false,
      },
    },
    handleScale: false,
    handleScroll: false,
  }

  useEffect(() => {
    const handleResize = () => {
      chart.applyOptions({ width: chartContainerRef.current.clientWidth })
    }

    const chart = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: chartContainerRef.current.clientHeight,
      ...chartOptions,
    })
    chart.timeScale().fitContent()

    const lineSeries = chart.addLineSeries({
      lineWidth: 1,
      priceLineVisible: false,
      color: isBelow ? 'rgba(223, 91, 107, 0.9)' : 'rgba(77, 188, 155, 0.9)',
    })
    lineSeries.setData(convertData)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      chart.remove()
    }
  }, [data])

  return <MiniChartContainer ref={chartContainerRef} />
}
